import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { useTranslation } from 'react-i18next';
import { CheckboxSettingUser } from '../_base/CheckboxSettingUser';
import { ENUM__settings_user_tab } from '../_base/ENUM__settings_user_tab';
import { S_TAB__user_wrapper } from '../_base/S_TAB__user_wrapper';
import { DropdownSettingUserLanguage } from './DropdownSettingUserLanguage';

export function S_TAB__regional() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { user_settings } = use_slice_user(['user_settings']);

  function render_checkbox_use_english_tokens() {
    if (user_settings.regional_language == ENUM__language_type.ENGLISH) return <></>;

    return (
      <CheckboxSettingUser
        settingKey="regional_use_english_tokens_in_prompt"
        i18nKey={i18n_page_settings_user.tabs.regional.prompt.use_english_tokens}
        disabled={user_settings.regional_language == ENUM__language_type.ENGLISH}
      />
    );
  }

  return (
    <S_TAB__user_wrapper type={ENUM__settings_user_tab.REGIONAL}>
      <div className="mt-1 flex flex-col justify-start items-start  text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_user.tabs.regional.title)}</span>
        <DropdownSettingUserLanguage />

        {render_checkbox_use_english_tokens()}
      </div>
    </S_TAB__user_wrapper>
  );
}
